module.exports = __webpack_public_path__ + "static/media/barranquilla.3e88f3b8.jpeg";